/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { AbstractRestService, optimisticLockingOf, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { MasterZoneModulePermissionTreeDto } from './master-zone-module-permission.dto';
import { MasterZoneModulePermissionTreeMapper } from './master-zone-module-permission.mapper';

@Injectable()
export class MasterZoneModulePermissionTreeRestService extends AbstractRestService {
  constructor(settings: RestSettings) {
    super(settings);
  }

  get(id: ID): Observable<MasterZoneModulePermissionTreeDto> {
    return this.httpGet(`${this.bp}/master-zones/${id}/permissions`, optimisticLockingOf(MasterZoneModulePermissionTreeMapper));
  }

  update(tree: MasterZoneModulePermissionTreeDto): Observable<MasterZoneModulePermissionTreeDto> {
    return this.httpPut(
      `${this.bp}/master-zones/${tree.masterZoneId}/permissions`,
      tree,
      optimisticLockingOf(MasterZoneModulePermissionTreeMapper));
  }
}
